import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
    height: "100%"
  },
  cardImage: {
    width: "100%",
    position: "absolute",
    margin: "auto",
    left: 0,
    right: 0,
    fill: theme.kooee.text.primary,
    stroke: theme.kooee.text.primary,
    strokeWidth: "2",
    [theme.breakpoints.up("md")]: {
      height: "3em"
    },
    [theme.breakpoints.between("sm", "md")]: {
      height: "8em"
    },
    [theme.breakpoints.down("sm")]: {
      height: "3em"
    },
    "@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (-webkit-min-device-pixel-ratio: 1)": {
      height: "3em"
    }
  },
  cardImageActive: {
    fill: "#fff",
    stroke: "#fff"
  },
  towerWrapper: {
    borderRadius: "32px"
  },
  first: {
    borderRadius: "32px 0 0 32px"
  },
  mid: {},
  last: {
    backgroundColor: "red",
    borderRadius: "0px 32px 32px 0"
  },
  only: {
    backgroundColor: "red",
    borderRadius: "32px"
  },
  panelImageWrapper: {
    padding: "0.4em 0em",
    "&> svg": {
      fill: "#fff",
      height: "2em"
    }
  },
  solar: {
    backgroundColor: "yellow"
  },
  battery: {
    backgroundColor: "green"
  },
  imageWrapper: {
    "&> svg": {
      height: "4em"
    }
  },
  section: {
    marginBottom: theme.spacing(1)
  },
  goBack: {
    textAlign: "left"
  },
  sliderWrapper: {
    marginTop: theme.spacing(1)
  },
  itemCards: {
    width: "12vw !important"
  },
  headerTitles: {
    fontWeight: 600
  }
}));
